var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"rc-input-button-green rc-input-good rc-input-width rc-text-small",staticStyle:{"padding":"5px"},attrs:{"type":"button","disabled":_vm.isDisabled,"value":_vm.label},on:{"click":_vm.pressed}})])
}
var staticRenderFns = []

export { render, staticRenderFns }